export const CLASS_INSTANCE_COLUMNS = [
  { id: "name", label: "Class", alwaysVisible: true, defaultVisible: true },
  { id: "template_name", label: "Template", alwaysVisible: false, defaultVisible: true },
  { id: "date_range", label: "Date range", alwaysVisible: false, defaultVisible: true },
  { id: "format", label: "Format", alwaysVisible: false, defaultVisible: true },
  { id: "capacity", label: "Capacity", alwaysVisible: false, defaultVisible: true },
  { id: "status", label: "Status", alwaysVisible: false, defaultVisible: true },
  { id: "instructors", label: "Instructors", alwaysVisible: false, defaultVisible: true },
];

export const SORT_OPTIONS = [
  { value: "first_session_starts_at asc", label: "Class date (earliest first)" },
  { value: "first_session_starts_at desc", label: "Class date (latest first)" },
  { value: "name asc", label: "Name (A-Z)" },
  { value: "name desc", label: "Name (Z-A)" },
  { value: "created_at desc", label: "Newest First" },
  { value: "created_at asc", label: "Oldest First" },
];

export const SORTABLE_COLUMNS = {
  name: "name",
  date_range: "first_session_starts_at",
};

export const tableSortFor = (sortBy) => {
  const [field, direction] = (sortBy || "").split(" ");
  const key = Object.keys(SORTABLE_COLUMNS).find((column) => SORTABLE_COLUMNS[column] === field);
  return key ? { key, direction } : undefined;
};
